import { ChangeDetectorRef, Component, OnInit, OnDestroy, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { Credentials } from '../shared/credentials.interface';
import { UserService } from '../shared/user.service';
import { Subscription } from 'rxjs';
import { loginError } from './loginError';
import { AutoLogoutService } from '../shared/auto-logout.service';
import { LoginStatus } from '../shared/login-status-service';
import { Schedule } from '../../shared/shared-schedule';
import { OrgNotProvisionedError } from '../../home/hub.service';


@Component({
    selector: 'app-login-form',
    templateUrl: './login-form.component.html',
    styleUrls: ['./login-form.component.css'],
    standalone: true,
    imports: [DatePipe, FormsModule, MatCardModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule]
})
export class LoginFormComponent implements OnInit, OnDestroy {

  private subscription: Subscription;

  brandNew = false;
  isRequesting = false;
  submitted = false;
  credentials: Credentials = { email: '', password: '' };
  errorReason: loginError = new loginError();
  dateTimeFormat = '';
  hidePassword = true;

  private userService = inject(UserService);
  private router = inject(Router);
  private autoLogout = inject(AutoLogoutService);
  private loginStatus = inject(LoginStatus);
  private cdr = inject(ChangeDetectorRef);

  ngOnInit() {

    if (sessionStorage.getItem('accessToken')) {
      this.router.navigate(['/dashboard']);
      return;
    }

    this.dateTimeFormat = Schedule.getAngularLocaleDateString();

  }

  ngOnDestroy() {
    // Called once, before the instance is destroyed.
    // Add 'implements OnDestroy' to the class.
    // this.subscription.unsubscribe();
  }

  login({ value, valid }: { value: Credentials, valid: boolean }) {
    this.submitted = true;
    this.isRequesting = true;
    this.errorReason = new loginError();
    const that = this;

    if (valid) {
      const stopSpinner = () => {
        that.isRequesting = false;
        that.cdr.markForCheck();
      };

      this.userService.login(value.email, value.password)
        .subscribe({
          next: result => {
            if (result.isValid) {
              that.userService.hasConfigBeenRun().subscribe({
                next: res2 => {
                  if (res2) {
                    that.userService.getOrgDetails().subscribe({
                      next: () => {
                        that.autoLogout.init();
                        // Navigate first so the login form is unmounted before
                        // the navbar flips to its logged-in state.
                        that.router.navigate(['/dashboard']).then(() => {
                          that.loginStatus.setStatus(true);
                          stopSpinner();
                        });
                      },
                      error: (err) => {
                        // ZDHub answering "no such org" is a different
                        // condition from ZDHub being unreachable, and needs a
                        // different message — the first is actionable by
                        // support, the second is "try again later".
                        if (err instanceof OrgNotProvisionedError) {
                          that.errorReason.noConfig = true;
                          that.errorReason.isValid = false;
                          that.errorReason.orgId = err.orgId;
                        }
                        else {
                          that.errorReason.generalError = true;
                          that.errorReason.generalErrorText = 'Could not load organisation details.';
                        }
                        stopSpinner();
                      }
                    });
                  }
                  else {
                    that.errorReason.noConfig = true;
                    that.errorReason.isValid = false;
                    that.errorReason.orgId = sessionStorage.getItem('orgId') ?? '';
                    stopSpinner();
                  }
                },
                error: () => {
                  that.errorReason.generalError = true;
                  that.errorReason.generalErrorText = 'Could not reach the configuration service.';
                  stopSpinner();
                }
              });
            }
            else {
              this.errorReason = result;
              stopSpinner();
            }
          },
          error: err => {
            const body = err?.error ?? {};
            if (body?.error === 'account_locked') {
              this.errorReason.accountLocked = true;
            }
            else if (typeof body?.error_description === 'string') {
              this.errorReason.generalError = true;
              this.errorReason.generalErrorText = body.error_description;
            }
            else {
              this.errorReason.generalError = true;
              this.errorReason.generalErrorText = '';
            }
            stopSpinner();
          }
        });
    }
  }
}
